import React, { useState, useRef } from "react";
import axiosInstance from "../../config/axiosConfig"; // Asegúrate de tener tu configuración de axios

const BuscarPaciente = ({ onSelect, onClear = () => {}, hideLabel = false, valoresTurnos = false, conAuxiliares = false, conAcuerdos = false, conVisita = false, conAcuerdosAuxiliar = false, conEnfermeria = false, conTurno = false, retirados = null}) => {
    const [pacientes, setPacientes] = useState([]); 
    const [textoBusqueda, setTextoBusqueda] = useState(""); 
    const [loading, setLoading] = useState(false); 
    const abortControllerRef = useRef(null);

    const buscarPacientes = async (e) => {
        const text = e.target.value;
        setTextoBusqueda(text);

        if (text.length < 2) {
            setPacientes([]);
            return;
        }

        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();

        setLoading(true); 

        try {
            const response = await axiosInstance.get(`/paciente/busqueda/texto`, {
                params: {
                    search: text,
                    valoresTurnos, 
                    conAuxiliares,
                    conAcuerdos,
                    conVisita,
                    conAcuerdosAuxiliar,
                    conEnfermeria,
                    conTurno,
                    retirados
                },
                signal: abortControllerRef.current.signal,
            });
            if (!response.data.error) {
                setPacientes(response.data.data);
            }
        } catch (error) {
            if (error.name !== "AbortError") {
                console.error(error);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSelectPaciente = (paciente) => {
        onSelect(paciente); 
        setTextoBusqueda(`${paciente.nombres} ${paciente.apellidoPaterno} ${paciente.apellidoMaterno} (${paciente.rut})`); 
        setPacientes([]); 
    };

    const handleClearSearch = () => {
        setTextoBusqueda(""); 
        setPacientes([]); 
        onClear(null);
    };

    return (
        <div className="position-relative buscador-container">
            {!hideLabel && <label className="form-label small fw-bold text-muted mb-1">Buscar Paciente</label>}
            <div className="input-group input-group-sm shadow-sm rounded">
                <span className="input-group-text bg-white border-end-0">
                    <i className="bi bi-search text-muted"></i>
                </span>
                <input
                    type="text"
                    className="form-control border-start-0 ps-0 shadow-none py-2"
                    value={textoBusqueda}
                    onChange={buscarPacientes}
                    placeholder="Escriba nombre o RUT..."
                    style={{ fontSize: '0.9rem' }}
                />
                {loading ? (
                    <span className="input-group-text bg-white border-start-0">
                        <div className="spinner-border spinner-border-sm text-primary" role="status" style={{ width: '0.8rem', height: '0.8rem' }}></div>
                    </span>
                ) : (textoBusqueda && ( 
                    <button
                        className="btn btn-white border border-start-0 text-muted"
                        type="button"
                        onClick={handleClearSearch}
                    >
                        <i className="bi bi-x-lg"></i>
                    </button>
                ))}
            </div>
            {pacientes.length > 0 && (
                <div className="position-absolute w-100 shadow-lg border rounded-bottom bg-white overflow-auto" style={{ zIndex: 10000, maxHeight: '300px', top: '100%', left: 0 }}>
                    <div className="list-group list-group-flush">
                        {pacientes.map((paciente) => (
                            <button
                                key={paciente.id}
                                type="button"
                                className="list-group-item list-group-item-action py-2 px-3 border-0 small d-flex flex-column"
                                onClick={() => handleSelectPaciente(paciente)}
                            >
                                <span className="fw-bold text-dark">{paciente.nombres} {paciente.apellidoPaterno} {paciente.apellidoMaterno}</span>
                                <span className="text-muted smaller" style={{ fontSize: '0.7rem' }}>RUT: {paciente.rut}</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default BuscarPaciente;
